'use client';

import classNames from 'classnames';
import { useParams, usePathname } from 'next/navigation';
import React, { FC, PropsWithChildren, useEffect } from 'react';

import { BLOG_ROUTE } from '@/app/[lang]/Router/routes';
import Link from '@/components/core/Link';
import useLocalStorage from '@/hooks/useLocalStorage';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

const List: FC<PropsWithChildren & { isColumn?: boolean }> = ({ children, isColumn }) => {
  const { t } = useTranslation();
  const params = useParams();
  const pathname = usePathname();

  const [scrollToUpcoming, setScrollToUpcoming] = useLocalStorage('scrollToUpcoming', false);

  useEffect(() => {
    if (scrollToUpcoming) {
      const element = document.getElementById('upcoming');
      if (!element) return;
      const currentScroll = window.pageYOffset;
      const elementPosition = element.getBoundingClientRect().top;
      const header = document.querySelector('.header') as HTMLElement | null;
      const headerHeight = header?.offsetHeight! + header?.scrollHeight!;

      const offsetPosition = currentScroll + elementPosition - headerHeight || 145;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
      setScrollToUpcoming(false);
    }
  }, [pathname]);

  return (
    <div className="eventTemplateWrapper" id="upcoming">
      <div className="bigContent">
        <div className="eventTemplateHolder">
          <div className="eventTemplateHeaderHolder">
            <div className="eventTemplateHeaderTxtHolder">
              <h2 className="eventTemplateHeaderTxt">{t('Homepage-Upcoming events')}</h2>
            </div>
            {!pathname.includes('upcoming-events') && (
              <div className="eventTemplateHeaderButton">
                <Link
                  href={`${BLOG_ROUTE.getPath(params.lang as string)}/upcoming-events`}
                  className="button btnTypeMedium btnTypeGray btnCircleMobile"
                  aria-label="explore more"
                  onClick={() => setScrollToUpcoming(true)}
                >
                  <p className="mobBtnTxt">{t('Explore more-Button')}</p>
                  <i className="bc-i-go-to btnIcon btnIconSmall" />
                </Link>
              </div>
            )}
          </div>
        </div>
        <div className={classNames('eventTemplateMainHolder', { withSlider: !isColumn })}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default List;
